import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';
import { AdminAssignDriverRequestSchema } from '../client-sdk';

export const useAssignDriverApi = () => {
    const api = useContext(HimmaContext)!;
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const assignDriver = useCallback(
        async (requestData: AdminAssignDriverRequestSchema) => {
            setLoading(true);
            setError(null);
            try {
                const response = await api.adminAssignDriver(requestData);
                return response.data;
            } catch (err) {
                setError(err instanceof Error ? err.message : 'An error occurred while assigning driver');
                throw err;
            } finally {
                setLoading(false);
            }
        },
        [api]
    );

    return {
        assignDriver,
        loading,
        error,
    };
};
